import { createGlobalStyle, css } from 'styled-components';
import SourceSansProLight from 'assets/fonts/SourceSansPro-Light.ttf';
import SourceSansProRegular from 'assets/fonts/SourceSansPro-Regular.ttf';
import { GlobalModalStyles } from './Modal.styles';
import { ScrollableShadowStyles } from './ScrollableShadow.styles';
import theme from './theme';

// BS5 utility classes that are not available in BS3 - this should be removed once migrated to BS5
const bootstrap5Adapter = css`
  .d-flex {
    display: flex !important;
  }

  .d-none {
    display: none !important;
  }

  .flex-column {
    flex-direction: column !important;
  }

  .invisible {
    visibility: hidden !important;
  }

  .bd-callout {
    padding: 1.25rem;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    border: 1px solid #e9ecef;
    border-left-width: 0.25rem;
    border-radius: 0.25rem;
  }

  .bd-callout {
    padding: 1.25rem;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    border: 1px solid #e9ecef;
    border-left-width: 0.25rem;
    border-radius: 0.25rem;
  }

  .bd-callout h4 {
    margin-bottom: 0.25rem;
  }

  .bd-callout p:last-child {
    margin-bottom: 0;
  }

  .bd-callout code {
    border-radius: 0.25rem;
  }

  .bd-callout + .bd-callout {
    margin-top: -0.25rem;
  }

  .bd-callout-info {
    border-left-color: #5bc0de;
  }

  .bd-callout-warning {
    border-left-color: #f0ad4e;
  }

  .bd-callout-danger {
    border-left-color: #d9534f;
  }
`;

const customBootstrap = css`
  .has-success .help-block,
  .has-success .control-label,
  .has-success .radio,
  .has-success .checkbox,
  .has-success .radio-inline,
  .has-success .checkbox-inline,
  .has-success .form-control-feedback,
  .has-success .input-group-addon,
  .has-success.radio label,
  .has-success.checkbox label,
  .has-success.radio-inline label,
  .has-success.checkbox-inline label {
    color: ${theme.colors.fontGreen} !important;
  }

  .has-success .form-control,
  .has-success .input-group-addon {
    border-color: ${theme.colors.fontGreen} !important;
  }
`;

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: SourceSansPro_light;
    src: url(${SourceSansProLight});
  }
  @font-face {
    font-family: SourceSansPro_regular;
    src: url(${SourceSansProRegular});
  } 

  html {
    font-size: 14px;
    font-family: 'Source Sans Pro', sans-serif;
  }

  body {
    font-family: 'Source Sans Pro', sans-serif;
    color: ${theme.colors.fontDark} !important;
  }

  div.tooltip a {
    color: #fff;
  }

  ${bootstrap5Adapter}

  ${customBootstrap}

  ${GlobalModalStyles}

  ${ScrollableShadowStyles}
`;

export default GlobalStyles;
